import type { AppRouter } from '@trapeze/server';
import { createTRPCReact } from '@trpc/react-query';

// This is the tRPC client for React Query
export const trpc = createTRPCReact<AppRouter>();
